import React from 'react'

import {
  type SanityTextContentProps,
  SanityTextRenderer,
} from '@slite/components'

import { Section } from '../../../components/Section'

// Renders the use-case rich-text body with the same layout + styling as blog
// posts (centered 8-col column, `simple-rich-text-sanity large`).
export function SectionUseCaseContent({
  content,
}: {
  content: SanityTextContentProps
}) {
  return (
    <Section background="moon-dust-lighter">
      <div className="grid-12">
        <div className="grid-span-8 grid-offset-2 grid-span-12-small grid-offset-0-small simple-rich-text simple-rich-text-sanity large">
          <SanityTextRenderer variant="website" content={content} />
        </div>
      </div>
    </Section>
  )
}
